module.exports = __webpack_public_path__ + "static/media/insights-img-2.f8bcfb6f.png";